import React, { Component } from "react";
import "./ErrorBoundary.css";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Vous pouvez également logger l'erreur ici
    console.error("🔥 Error Boundary CATCH:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-page">
          <div className="error-boundary-box">
            <div className="error-boundary-icon">⚠️</div>
            <h1>Une erreur est survenue</h1>
            <p>
              Merci d’actualiser la page. <br />
              Si le problème persiste, veuillez rapporter cette erreur à notre
              service technique.
            </p>
          </div>
          <p className="error-boundary-footer">
            © {new Date().getFullYear()} EVE Éducation
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
